import React from "react";
import { CircularProgress } from "@mui/material";
import Questions from "components/courses/viewcourse/course-resume/Quiz/Questions";

const noop = () => {};

const AttemptDetail = ({ attempt, questions, loadingQuestions }) => {
  if (!attempt) return null;

  const results = attempt.results || [];
  const hasFullResults = results.length > 0;

  const selectedAnswers = results.reduce((acc, r) => {
    acc[r.questionId] = r.userAnswer;
    return acc;
  }, {});

  return (
    <div>
      <div
        className="d-flex flex-wrap gap-3 align-items-center p-3 rounded-3 mb-3"
        style={{ background: "#f0f4f8", border: "1px solid #d1d9e6" }}
      >
        <div>
          <div className="text-muted small">Attempt</div>
          <div className="fw-bold">{attempt.attemptNumber}</div>
        </div>
        <div className="border-start ps-3">
          <div className="text-muted small">Score</div>
          <div className="fw-bold">
            {attempt.totalQuestions
              ? `${attempt.correctQuestions} / ${attempt.totalQuestions}`
              : "—"}
            <span className="text-muted ms-1">({attempt.percentage.toFixed(0)}%)</span>
          </div>
        </div>
        {attempt.passed !== null && (
          <div className="border-start ps-3">
            <div className="text-muted small">Result</div>
            <div className={`fw-bold ${attempt.passed ? "text-success" : "text-danger"}`}>
              {attempt.passed ? "Passed" : "Failed"}
            </div>
          </div>
        )}
      </div>

      {attempt.passed !== true ? (
        <div className="text-muted small p-3 text-center">
          Detailed question-by-question review is only shown once you pass this quiz.
        </div>
      ) : !hasFullResults ? (
        <div className="text-muted small p-3 text-center">
          Detailed question-by-question breakdown isn't available for this attempt.
        </div>
      ) : loadingQuestions ? (
        <div className="text-center p-4">
          <CircularProgress size={28} />
        </div>
      ) : questions && questions.length > 0 ? (
        <Questions
          questions={questions}
          selectedAnswers={selectedAnswers}
          onAnswerChange={noop}
          isReview={true}
          correctAnswers={[]}
          result={results}
          startIndex={1}
        />
      ) : (
        <div className="d-flex flex-column gap-2">
          {results.map((r, idx) => (
            <div
              key={r.questionId}
              className="p-2 rounded-3 border"
              style={{ borderColor: r.evaluation?.is_correct ? "#c3e6cb" : "#f5c6cb" }}
            >
              <div className="d-flex justify-content-between small">
                <span className="fw-bold">Q{idx + 1}</span>
                <span className={r.evaluation?.is_correct ? "text-success" : "text-danger"}>
                  {r.evaluation?.is_correct ? "Correct" : "Incorrect"}
                </span>
              </div>
              <div className="small text-muted">Your answer: {String(r.userAnswer ?? "—")}</div>
              {r.evaluation?.message && (
                <div className="small text-muted">{r.evaluation.message}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AttemptDetail;
